import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import InputNumber from '@/components/BuyLoad/InputNumber'
import Dummy from '@/components/Dummy'
import SelectLoadType from '@/components/BuyLoad/SelectLoadType'
import Cashier from '@/components/BuyLoad/Cashier'
import OTP from '@/components/BuyLoad/OTP'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/dummy',
      name: 'Dummy',
      component: Dummy
    },
    {
      path: '/buy-load/input-number',
      name: 'InputNumber',
      component: InputNumber
    },
    {
      path: '/buy-load/select-load-type',
      name: 'SelectLoadType',
      component: SelectLoadType
    },
    {
      path: '/buy-load/cashier',
      name: 'Cashier',
      component: Cashier
    },
    {
      path: '/buy-load/otp',
      name: 'OTP',
      component: OTP
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js